
const notEmpty = function(valueToValidate){

    const isString = typeof valueToValidate === 'string'
    const isBoolean = typeof valueToValidate === 'boolean'

    const isValid = isString ? !!(valueToValidate.length > 1) : isBoolean ? valueToValidate : false
    return isValid
}

export default notEmpty
